import script from "./RecoverPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoverPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./RecoverPasswordForm.vue?vue&type=style&index=0&id=c7f8fb7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7f8fb7e"]])

export default __exports__